(() => {
  const meters = ['variety', 'swedish-2lb', 'halloween', 'fruity', 'neighborhood'].map((name) => {
    const element = document.getElementById(`${name}-stock`);
    const total = Number(element?.dataset.inventoryTotal);
    if (!element || !Number.isSafeInteger(total) || total <= 0) return null;
    const copy = element.querySelector('.tbtt-stock-copy');
    const fill = element.querySelector('.tbtt-stock-track > span');
    if (!copy || !fill) return null;
    return {
      name, inventoryKey: element.dataset.inventoryKey || name, element, total, copy, fill,
      button: element.parentElement?.querySelector('.review-order-form .tbtt-button'),
    };
  }).filter(Boolean);
  const endpoint = meters[0]?.element.dataset.inventoryEndpoint;
  if (!endpoint) return;

  function updateMeter(meter, count) {
    if (!Number.isSafeInteger(count) || count < 0) return;
    const available = Math.min(count, meter.total);
    const revealAt = Number(meter.element.dataset.inventoryRevealAt);
    const displayed = Number.isSafeInteger(revealAt) && revealAt > 0 ? count : available;
    meter.element.dataset.inventoryAvailable = String(displayed);
    meter.element.dataset.inventorySource = 'shopify-admin-endpoint';
    if (Number.isSafeInteger(revealAt) && revealAt > 0) {
      meter.element.hidden = count > revealAt || count === 0;
    }
    meter.copy.textContent = count === 0
      ? 'Sold out'
      : `Only ${displayed} packs left`;
    meter.fill.style.width = `${((meter.total - available) / meter.total) * 100}%`;
    if (!meter.button) return;
    if (count === 0 && !meter.button.disabled) {
      meter.button.dataset.inventoryDisabled = 'true';
      meter.button.disabled = true;
      meter.button.classList.add('tbtt-button--sold-out');
      meter.button.textContent = 'Sold Out';
    } else if (count > 0 && meter.button.dataset.inventoryDisabled === 'true') {
      meter.button.disabled = false;
      meter.button.classList.remove('tbtt-button--sold-out');
      meter.button.textContent = 'Add to order';
      delete meter.button.dataset.inventoryDisabled;
    }
  }

  let inFlight = false;
  function reloadForVarietySuccessor(meter) {
    if (meter.inventoryKey !== 'variety_v2') return;
    const throttleKey = 'tbtt-variety-v3-cascade-reload';
    try {
      const lastReload = Number(sessionStorage.getItem(throttleKey) || 0);
      if (Date.now() - lastReload < 60_000) return;
      sessionStorage.setItem(throttleKey, String(Date.now()));
      window.location.reload();
    } catch {
      // The V2 button remains sold out if storage is unavailable.
    }
  }
  async function refresh() {
    if (inFlight || document.visibilityState === 'hidden') return;
    inFlight = true;
    try {
      const response = await fetch(endpoint, { cache: 'no-store', mode: 'cors' });
      if (!response.ok) return;
      const result = await response.json();
      for (const meter of meters) {
        const count = result.packs?.[meter.inventoryKey]?.available;
        updateMeter(meter, count);
        if (count === 0) reloadForVarietySuccessor(meter);
      }
    } catch {
      // Keep Shopify's server-rendered counts if the endpoint is unavailable.
    } finally {
      inFlight = false;
    }
  }

  refresh();
  window.setInterval(refresh, 60_000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
})();
